export default __webpack_public_path__ + "static/Product-reviews-f1e8d3c0be5e91a31b34820e505a0923.webp";